import { listenerMiddleware } from "../../../store/middleware";
import { setIsWhiteboardActive, setNotificationActive } from "./whiteboardSlice";

listenerMiddleware.startListening({
    actionCreator: setIsWhiteboardActive,
    effect: async (action, listenerApi) => {
        console.log("[WhiteboardMiddleware] setIsWhiteboardActive triggered with payload:", action.payload);
        if (!action.payload) {
            const state = listenerApi.getState();
            const { whiteboardId } = state.whiteboard;
            const localAvatarId = state.auth.localAvatar.id;
            // Only display reset notification if the local avatar is the owner of the whiteboard
            if ( whiteboardId && whiteboardId === `whiteboard-${localAvatarId}`) {
                listenerApi.dispatch(setNotificationActive(true));
            }
        }

    }
})